import { faTable } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import api from "../../api/api";
import { Oval } from "react-loader-spinner";

const PurgeDatabaseScreen = () => {
  const [selectedTables, setSelectedTables] = useState([]);
  const [password, setPassword] = useState("");
  const [isPurging, setIsPurging] = useState(null);
  const [message, setMessage] = useState("");
  const [tables, setTables] = useState([]);
  

  


  useEffect(()=>{

    const fetchData = async ()=>{

        
        try{

            const tables = await api.get('/database')
            setTables(tables.data);
            
        }catch(e){

            console.log(e)
        }
    }

    fetchData()

  }, [])



  const purge = async (table)=>{

    try{
        setIsPurging(table)
        await api.post('/database/purge', {table : table})
        
        // setTables((table)=>[...table.filter((item)=>item[0] !== table)])
        window.location.reload()

    }catch(e){

        console.log(e)
    } 

    setIsPurging(null)

  }

  return (
    <div className="flex-col items-start justify-center h-screen p-5">
        <div className="w-full px-6 py-5 pt-6 bg-indigo-600 rounded-lg shadow-lg fade-in">
            
            <div className="">
                
                <div className="mb-4 text-left">
                    <h1 className="text-2xl font-bold text-gray-100">Base de donnée kiloutou</h1>
                </div>
                <div className="mb-4 text-left">
                    <span className="mx-1 text-lg font-bold text-gray-100">{tables?.length}</span>
                    <span className="mx-1 text-lg font-bold text-gray-100">Table{tables?.length > 1 ? 's' : ''}</span>
                </div>
                <div className="py-2 border-t-2 rounded-0 border-t-gray-100">
                    <div className="my-1 text-left text-green-300">
                        <span className="mx-1 text-sm ">{tables.map((item)=>item[1].totalRows).reduce((acc, current) => acc + current, 0)}</span>
                        <span className="mx-1 text-sm ">Lignes</span>
                    </div>

                    <div className="inline my-1 text-left text-red-300">
                        <span className="mx-1 text-sm">{tables.map((item)=>item[1].deletedRows).reduce((acc, current) => acc + current, 0)}</span>
                        <span className="mx-1 text-sm">Lignes suprimées</span>
                    </div>
                </div>
                
            </div>

            
        
        </div>


        <div className="w-full p-8 my-10 bg-white rounded-lg shadow-lg fade-in dark:bg-gray-800">
            <h2 className="mb-4 text-2xl font-bold text-center text-gray-800">
                Statistique des Tables
            </h2>
            <div className="flex flex-col items-center justify-center gap-4">
            {tables.length > 0  ?
                tables?.map((item, idx)=>(
                    <div key={idx} className="w-full px-4 py-4 bg-gray-200 rounded-lg dark:bg-gray-700">
                        <div className="flex flex-row items-center justify-start w-full mb-2">
                            <div>
                                <FontAwesomeIcon icon={faTable} className="text-indigo-700"/>
                                <span className="mx-2 font-semibold text-gray-800 dark:text-gray-200">{item[0]}</span>
                            </div>

                            {(isPurging !== item[0] && item[1].deletedRows > 0) && <div className="px-4 py-1 mx-5 bg-red-500 rounded-lg cursor-pointer bg-opacity-10 hover:bg-red-700 hover:bg-opacity-10"
                                onClick={async()=>await purge(item[0])}
                            >
                                <span className="font-semibold text-red-600">Purger</span>
                            </div>}

                            <div className="flex items-center justify-center px-4 py-2 text-white rounded cursor-progress ">
                                {(isPurging === item[0]) && <Oval
                                height={20}
                                width={20}
                                color="#ffffff"
                                visible={true}
                                ariaLabel="oval-loading"
                                secondaryColor="#cccccc"
                                strokeWidth={2}
                                strokeWidthSecondary={2}
                                />}
                            </div>
                        </div>
                        
                        <div className="my-1 text-green-600">
                            {item[1].totalRows} Lignes
                        </div>
                        <div className="my-1 text-red-600">
                            {item[1].deletedRows} lignes supprimées
                        </div>

                        
                    </div>
                ))
                :
                <p className="dark:text-gray-200">Aucune table</p>
            }
            </div>
        </div>
        
    </div>
  );
};

export default PurgeDatabaseScreen;
